import Navigation from './Navigation'
import Hamburger from './Hamburger'
import AnchorScroll from './AnchorScroll'
import Accordion from './Accordion'
import LoopTextAnimation from './LoopTextAnimation'
import DropDown from './DropDown'
import AutoMovingSlides from './AutoMovingSlides'
import ScrollManager from './ScrollManager'
import Details from './Details'
import FloatingNav from './FloatingNav'
import Redirect from './Redirect'
import ScrollTriggerClass from './ScrollTriggerClass';

export default class {
  constructor() {

    const domNavigation = document.querySelector('[data-js="navigation"]');
    if (domNavigation) new Navigation(domNavigation);

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    const domDropDown = document.querySelectorAll('[data-js="dropdown-trigger"]');
    if (domDropDown) {
      [...domDropDown].forEach(el => {
        new DropDown(el);
      })
    }

    const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    if ( domAnchorScroll ) {
      domAnchorScroll.forEach(el => {
        new AnchorScroll(el);
      });
    }

    const domScroller = document.querySelector('[data-scroller]');
    if (domScroller) new ScrollManager(domScroller);

    const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    if (domAccordion) {
      [...domAccordion].forEach(el=>{
        new Accordion(el);
      });
    }

    const domLoopTextAnimation = document.querySelectorAll('[data-js="tick"]');
    if (domLoopTextAnimation) new LoopTextAnimation(domLoopTextAnimation);  

    const domAutoMovingSlides = document.querySelectorAll('[data-js="auto-slide"]');
    if (domAutoMovingSlides) {
      [...domAutoMovingSlides].forEach(el=>{
        new AutoMovingSlides(el);
      })
    }

    const domDetails = document.querySelectorAll('details');
    domDetails.forEach(el => new Details(el));

    const domFloatingNav = document.querySelector('.l-floatingnav');
    if (domFloatingNav !== null) {
      new FloatingNav(domFloatingNav);
    }

    const domScrollTriggerClass = document.querySelector('[data-trigger="stc-container"]');
    if (domScrollTriggerClass) new ScrollTriggerClass(domScrollTriggerClass);  

    new Redirect()
  }
}
